<script lang="ts" setup>
defineOptions({
  name: 'PageFooter',
});
// import { ref } from 'vue';
// import { useElementVisibility } from '@vueuse/core';
// const footer = ref(null);
// const isVisible = useElementVisibility(footer);
</script>

<template>
  <footer class="mx-auto w-1200px pb-64px" ref="footer">
    <!-- <div class="registrationCode" v-if="!isVisible">
      <img src="@/summit/2023/assets/code.png" alt="">
      <p>扫码立即报名峰会</p>
    </div> -->
    <div class="flex justify-between">
      <div>
        <div class="h-56px w-400px">
          <img src="@/summit/2023/assets/common/logo.png" alt="LOGO" class="block h-full w-full object-contain">
        </div>
        <div class="mt-32px h-32px text-18px text-#2d2d2d font-medium leading-32px tracking-3px">
          感谢您关注·2023开放原子全球开源峰会·
        </div>
        <p class="mt-4px text-14px text-#747678 font-normal leading-24px">
          主办单位： 2023全球数字经济大会组委会<br>
          承办单位：开放原子开源基金会 北京市经济和信息化局 北京经济技术开发区管理委员会
        </p>
      </div>
      <div class="flex justify-end">
        <div class="w-140px">
          <img src="@/summit/2023/assets/footer/more-detail.png" alt="LOGO" class="block h-140px w-full rounded-4px object-contain">
          <span class="mt-8px block h-24px text-center text-14px text-#747678 font-normal leading-24px">了解更多峰会信息</span>
        </div>
        <!-- <div class="ml-64px w-140px">
          <img src="https://res.oafimg.cn/-/f0b41102a0b535bb/14501686023013_.pic.jpg" alt="LOGO" class="block h-140px w-full rounded-4px object-contain">
          <span class="mt-8px block h-24px text-center text-14px font-normal leading-24px text-#747678">报名通道</span>
        </div> -->
      </div>
    </div>
    <div class="mb-24px mt-31px h-1px w-full bg-[#747678] opacity-10"></div>
    <p class="h-20px flex items-center text-14px text-#747678 font-normal">
      <span>
        Copyright 2023 OPENATOM FOUNDATION. All rights reserved.&nbsp;
        开放原子开源基金会版权所有&nbsp;
      </span>
      <a href="https://beian.miit.gov.cn/" target="_blank">京ICP备2020036654号-1</a>
      <img src="https://res.oafimg.cn/-/e2468638b6adb4de/police.png" alt="police" class="ml-5px inline-block h-16px w-16px">
      <span>京公网安备 11010801433219号</span>
    </p>
  </footer>
</template>

<style lang="scss" scoped>
.registrationCode {
  position: fixed;
  right: 0;
  bottom: 0;
  z-index: 10;
  display: flex;
  justify-content: center;
  width: 188px;
  text-align: center;

  p {
    position: absolute;
    bottom: 22px;
    width: 132px;
    color: #747678;
    font-weight: 500;
    font-size: 16px;
    line-height: 24px;
    background: linear-gradient(93.6deg, rgb(25, 51, 143) 0%, rgb(32, 144, 204) 49%, rgb(128, 196, 141) 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }
}
</style>
